import { render, staticRenderFns } from "./EditorMenu.vue?vue&type=template&id=34e49d74&scoped=true"
import script from "./EditorMenu.vue?vue&type=script&lang=ts"
export * from "./EditorMenu.vue?vue&type=script&lang=ts"
import style0 from "./EditorMenu.vue?vue&type=style&index=0&id=34e49d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e49d74",
  null
  
)

export default component.exports